import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet'; // Import Helmet for managing head tags
import SignupForm from './utils/SignupForm';
import HealthSection from './utils/HealthSection';

const NDIS = () => {
    return (
        <div>
{/* While we test GTM for now, we have removed the Google Analytics code from here */}

            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Unraveling the Potential of Lumbar Traction Therapy</h1>
                    <h2>Explore lumbar traction, a therapeutic modality for back pain relief, examining its effectiveness and applications within physiotherapy and chiropractic care at Ramp Physio and Fitness.</h2>
                    <p>At Ramp Physio and Fitness, we understand that back pain can be a debilitating experience, affecting every aspect of your daily life. Among the various treatment options available, lumbar traction therapy has emerged as a notable consideration for those suffering from spinal conditions. In this article, we delve into the intricacies of lumbar traction, shedding light on its role in managing back pain, the science behind the therapy, and its place in modern physiotherapy practices.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>The Science of Spinal Relief</h1>
                        <p>Lumbar traction therapy is a form of decompression therapy that aims to alleviate back pain by stretching the spine. The theory behind this treatment suggests that by gently pulling apart the vertebrae, pressure on the spinal discs and nerves can be reduced, potentially providing relief from pain and improving functionality. While traction can be applied manually by a therapist or mechanically using specialized equipment, it is essential to understand that the approach must be tailored to the individual's specific condition and needs.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Effectiveness of Lumbar Traction</h1>
                        <p>The question of whether lumbar traction is an effective treatment for back pain has been the subject of considerable debate within the medical community. Studies have shown mixed results, with some patients experiencing significant improvements in pain and mobility, while others notice little to no benefit. However, it is widely agreed that the success of lumbar traction depends on various factors, including the nature and severity of the spinal condition being treated, the method of traction used, and the overall health and lifestyle of the patient.</p>
                </div>
            </div>
            </SkewedContainer>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Therapeutic Applications and Limitations</h1>
                        <p>While lumbar traction may offer benefits for certain spinal conditions, such as herniated discs, sciatica, and degenerative disc disease, it is not a universal remedy. It is crucial for patients to undergo a thorough assessment by a qualified healthcare professional, like those at Ramp Physio and Fitness, to determine if traction therapy is suitable for their specific situation. Additionally, it is important to recognize that lumbar traction is often most effective when incorporated into a comprehensive treatment plan that may include physical therapy, exercise, and other modalities.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Navigating Treatment Options</h1>
                    <p>For individuals seeking relief from back pain, navigating the array of treatment options can be overwhelming. At Ramp Physio and Fitness, our team of physiotherapists and healthcare professionals are dedicated to providing personalized care that aligns with the latest evidence-based practices. We work closely with our patients to explore all potential treatment approaches, including lumbar traction, to develop a plan that addresses their unique needs and goals. By fostering a collaborative and informed therapeutic environment, we strive to optimize outcomes and enhance the quality of life for those we serve.</p>
                    <br></br>
                    <p>
                    In conclusion, lumbar traction therapy represents a potential avenue for relief for many individuals struggling with back pain. However, as with all treatments, it is not a one-size-fits-all solution. At Ramp Physio and Fitness, we are committed to offering top-tier sports injury management, physiotherapy, and personalized training that includes a careful consideration of lumbar traction as part of our holistic approach to healthcare. Whether you are an athlete managing a sports injury or someone coping with chronic pain, our team is here to support you on your journey to recovery and improved wellbeing.
                    </p>
                </div>
            </div>
            </SkewedContainer>
            <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default NDIS;
